<template>
  <div class="pc_comments">
    <el-table :data="tableData.list" @row-click="comjump">
      <el-table-column prop="ctime" label="日期" align="center">
      </el-table-column>
      <el-table-column prop="content" label="内容" width="260">
      </el-table-column>
      <el-table-column prop="click" label="访问量" >
      </el-table-column>
      <el-table-column prop="comment" label="评论量" >
      </el-table-column>
      <el-table-column prop="examine" label="状态" >
        <template slot-scope="scope">
          <span>{{scope.row.examine*1==0?"待审核":"审核通过"}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
        <div @click.stop>
          <el-popconfirm
            title="确定要删除该项吗？"
            @onConfirm='cancel(scope.row.id)'
          >
            <el-button type="danger" slot="reference">删除</el-button>
          </el-popconfirm>
        </div>
      </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @current-change="handleCurrentChange"
      :current-page="tableData.pagelistnum"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="上一页"
      next-text="下一页"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
    <el-dialog
      title="详情"
      :visible.sync="centerDialogVisible"
      width="650px"
      :before-close="beforeClose"
      :append-to-body="true"
      center>
      <div class="comment" v-if="detailsList[0]">
        <div class="userMessage">
          <div>
            <img v-lazy="detailsList[0].img" alt=""/>
            <span class="name">{{detailsList[0].name?detailsList[0].name:detailsList[0].nickname}}</span>
            <span>{{detailsList[0].duties}}</span>
            <span>{{detailsList[0].corpname}}</span>
            <span>{{detailsList[0].ctime}}</span>
          </div>
        </div>
        <p>{{detailsList[0].content}}</p>
        <div v-if="detailsList[0].address" class="address">
          <img class="imgIcon" v-lazy="hrefurl+'/public/icon/address.png'" alt=""/>
          {{detailsList[0].address}}
        </div>
        <div v-if="detailsList[0].supply_img" class="commentImg" ref="commentImg">
          <div class="userImg" ref="userImg">
            <div v-for="(item,i) in detailsList[0].supply_img" :key="i">
              <img v-lazy="item.img_url" :alt="item.img_info_cn"/> 
            </div>
          </div>
        </div>
      </div>
      <div class="area" >
        <ul class="areaList" v-if="detailsList[1]">
          <li class="areaItem" v-for="(areaItem,i) in detailsList[1]" :key="'area'+i">
            <img v-lazy="areaItem.img" alt=""/>
            <div class="con">
              <span class="areaName">{{areaItem.name?areaItem.name:areaItem.nickname}}：</span>
              <span class="areaContent">{{areaItem.comment}}</span> 
              <p>
                <span class="areaTime">{{areaItem.ctime}}</span>
                <span class="praise">99</span>
              </p>
            </div>
          </li>
        </ul>
        <div class="discussArea">
          <textarea class="discuss" placeholder="请输入内容" name="" id="" cols="30" rows="10" v-model="content"></textarea>
          <button @click="sendComment">发送</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reqComment, reqMyGongxu, reqMyGongxuDel, reqComments } from "../../api";
export default {
  props:["gongxu"],
  data(){
    return{
      tableData: {
        pagelistnum:0,
        listnum:0,
        list:[],
      },
      centerDialogVisible:false,
      detailsList:[],//详情信息
      content:"",//输入评论内容
      current:Number,//当前选中评论ID
    }
  },
  mounted(){
    this.init(this.gongxu)
  },
  methods:{
    async init(gongxu="gong",p=1){
      const response = await reqMyGongxu(gongxu,p)
      if (response.code*1==2) {
        this.tableData={
          pagelistnum:response.pagelistnum,
          listnum:response.listnum,
          list:response.resilt
        }
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"登录失效，请重新登录")
      }else if (response.code*1==1) {//无数据
      }
    },
    comjump(tr){
      this.popup(tr.id)
    },
    async cancel(id){//删除
      const response = await reqMyGongxuDel(id)
      if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"登录失效，请重新登录")
      }else if (response.code*1==1) {//删除项不存在
        this.err(this,"删除无效，请刷新后尝试")
      } else if (response.code*1==2) {//删除失败
        this.err(this,"删除失败，请重新尝试")
      } else if(response.code*1==3){//删除成功
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) this.tableData.list.splice(index,1)
        this.success(this,'删除成功！')
        
      } 
    },
    handleCurrentChange(p){//分页
      this.init(this.gongxu,p)
    },
    async popup(id){// 详情页弹窗请求
      const response = await reqComment(id)
      if (response.code*1==1) {
        this.detailsList=response.msg
        this.centerDialogVisible=true
        this.current = id
      }
    },
    async sendComment(){//发送评论
      let cent = this.content.trim()
      let isLogin = this.jump(this)
      // 当前用户id：this.user.id;
      //当前选中动态的id：this.current
      if (!cent.length&&!isLogin) return
      // 发送请求
      const response = await reqComments({sid:this.current,comment:this.content})
      if (response.code==1) {
        this.success(this,'评论提交成功，请耐心等待审核。。。')
        this.content=""
      } else if(response.code==0) {
        this.err(this,'评论失败，请稍后重试。。。')
      }else if(response.code==2){
        this.err(this,'登录失效，请重新登录。。。')
        // this.jump(this)
        this.$store.dispatch("outLogin")
        this.$store.dispatch("dialog",true)
      }
    },
  }
}
</script>

<style scoped>
  .pc_comments>>>.el-table--fit{
    width: 100%;
    box-sizing: border-box;
  }
  .pc_comments>>>.el-table tr{
    cursor: pointer;
  }
  .pc_comments>>>.el-table .cell{
    max-height: 75px;
    padding-right: 12px;
  }

  /* 分页 */
  .pc_comments>>>.el-pagination{
    padding-top: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .pc_comments>>>.el-dialog,
  .pc_comments>>>.el-pager li,
  .pc_comments>>>.el-pagination,
  .pc_comments>>>.el-pagination .btn-next,
  .pc_comments>>>.el-pagination .btn-prev,
  .pc_comments>>>.el-pagination button:disabled{
    background: none;
  }
</style>
<style scoped>
/* 详情内容 */
  .userMessage img{
    width: 30px;
    overflow: hidden;
    border-radius: 50%;
  }
  .userMessage .name{
    margin: 0 10px;
  }
  .comment{
    padding-bottom: 20px;
    border-bottom: 1px solid #aaa;
  }
  .comment>p{
    padding: 8px 14px;
  }
  .address{
    padding: 8px;
  }
  .address img{
    width: 20px;
  }
  .userImg>div{
    width: 160px;
    height: 146px;
    display: inline-block;
    padding-left: 14px;
  }
  /* 评论列表 satrt */
  .supplyMain>>>.el-dialog{
    max-width: 880px;
  }
  .area{
    width: 100%;
    max-height: 400px;
    /* height: 300px; */
    padding: 10px 20px 0;
    overflow-y: auto;
  }
  .areaItem{
    border-top: 1px dashed #aaa;
    padding: 10px 0;
    position: relative;
  }
  .areaItem:first-child{
    border: none;
  }
  .areaItem>.con{
    padding: 0 40px 10px;
    /* padding-bottom: 10px; */
    width: 100%;
  }
  .areaItem img{
    width: 34px;
    float: left;
  }
  .areaName{
    color: #6e6e6e;
    font-size: 14px;
  }
  .areaTime{
    color: #6e6e6e;
    font-size: 12px;
  }
  .areaContent{
    /* padding: 0 30px 20px; */
    font-size: 14px;
  }
  .praise{
    float: right;
    display: none;
  }
  .cancel{
    position: absolute;
    right: 2px;
    /* top: 5px; */
    bottom: 10px;
  }
  .cancel>>>.el-button{
    padding: 6px 8px;
  }
  .discussArea{
    /* border: 1px solid #aaa; */
    position: relative;
    height: 120px;
    margin: 0 4px;
    overflow: hidden;
  }
  .discuss{
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    color: #606266;
    width: 100%;
    height: 100%;
    /* background-color: rgb(240, 240, 240); */
    padding: 20px;
    font-size: 14px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .discuss:focus{
    outline: none;
    border-color: #409eff;
  }
  .discussArea>button{
    position: absolute;
    right: 10px;
    bottom: 2px;
    padding: 6px 18px;
    border-radius: 4px;
    outline: none;
    border: 1px solid #dcdfe6;
    background-color: white;
    /* box-shadow: 0 0 10px; */
    /* border: none; */
    cursor: pointer;
  }
  .discussArea>button:hover{
    color: #409eff;
    border-color: #409eff;
  }
  
  /* 评论列表 end */
</style>